import { render } from "./LegoIcon.vue?vue&type=template&id=5df81174&scoped=true"
import script from "./LegoIcon.vue?vue&type=script&lang=js"
export * from "./LegoIcon.vue?vue&type=script&lang=js"

import "./LegoIcon.vue?vue&type=style&index=0&id=5df81174&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5df81174"

export default script